import React, { useState, useEffect } from "react"
import { AppFunctionComponent } from "../../../types"

import {
  MusicPlayerEQContainer,
  AnimationBars,
  AnimationBar,
  AnimationBarWrapper,
} from "./audio-player-eq.styled"

export interface AudioPlayerEQProps {
  bar: number
  playing: boolean
  currentTrack: string
}

export const AudioPlayerEQ: AppFunctionComponent<AudioPlayerEQProps> = ({
  bar = 50,
  playing,
  currentTrack,
}) => {
  const generateRandomBars = () =>
    Array.from({ length: bar }).map(() => 0.3 + Math.random() * 0.5)
  const [playerBars, setPlayerBars] = useState(generateRandomBars())

  useEffect(() => {
    setPlayerBars(generateRandomBars())
  }, [currentTrack])

  return (
    <MusicPlayerEQContainer>
      <AnimationBars>
        {playerBars.map((duration, barIndex) => (
          <AnimationBarWrapper key={barIndex}>
            <AnimationBar duration={duration} animated={playing} />
          </AnimationBarWrapper>
        ))}
      </AnimationBars>
    </MusicPlayerEQContainer>
  )
}
